import api from '../services/api'

export default {
    
    fetchCurrentUser(){
        return api.get(`users/current_user/`)
                .then(response => response.data).catch(error => {
            Promise.reject(error)
          });
    },
    
            }